import { render, staticRenderFns } from "./Swatches.vue?vue&type=template&id=0cad0af4&"
import script from "./Swatches.vue?vue&type=script&lang=js&"
export * from "./Swatches.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports